import React, { useState, useEffect } from "react"
import * as Style from "./Form.module.scss"
import Input from "../UI/input/Input"
import Animation from "../animation/Animation"
import Button from "../UI/button/Button"

import useValidate from "../custom_hooks/use-validate"
import Icon from "../../images/exclamation.svg"

const Form = props => {
  const data = props.data
  const buttonText = data.button.button_title
  const inputs = data.input
  const title = data.title.split(":")
  const subTitle = data.sub_title

  const { inputHandler, formHandler, inputState, submit } =
    useValidate("CONTACT")

  return (
    <section className={Style.form}>
      <div className={Style.title}>
        <h2>{title[0]}:</h2>
        <h2>{title[1]}</h2>
        <p>{subTitle}</p>
      </div>

      <form className={Style.mainForm} onSubmit={formHandler}>
        <div className={Style.animationPosition}>
          <div className={Style.animationWrapper}>
            <Animation />
          </div>
        </div>
        {inputs.map(ele => {
          return (
            <div
              key={ele.id}
              className={
                submit === true && !inputState[ele.type]["valid"]
                  ? `${Style.invalidInputSpan} ${Style.inputSpan}`
                  : Style.inputSpan
              }
            >
              <span
                className={
                  ele.type === "number"
                    ? `${Style.inputInt} ${Style.inputText}`
                    : Style.inputText
                }
              >
                {ele.placeholder}
              </span>
              <Input
                style={ele.type === "number" ? Style.numberInput : ""}
                inputHandler={inputHandler}
                data={ele.type}
                type={ele.type}
                inputValue={inputState[ele.type]["val"]}
              />

              {submit && !inputState[ele.type]["valid"] && (
                <div className={Style.invalidTextWrapper}>
                  <Icon />
                  <p className={Style.invalidText}>
                    {`Невалидни данни: ${ele.placeholder.toLowerCase()}`}{" "}
                  </p>
                </div>
              )}
            </div>
          )
        })}
        <Button style={Style.btn}>{buttonText}</Button>
      </form>
    </section>
  )
}

export default Form
